import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  PageSubTitle,
  Text,
  Heading,
  Icon,
  WithTooltip
} from 'components/common/Elements/Elements';

import BodyTooltip from '../BodyTooltip/BodyTooltip';

import { upFirstLetter } from 'utils/common';

import classes from './AdditionalContent.module.scss';

const AdditionalContent = ({ data }) => {
  return (
    <>
      <PageSubTitle
        title={data.name}
        className={classes.title}
        classNameHeading={classes.heading}
        size={2}
      />
      <div className={classes.infoWrap}>
        <div className={classes.infoItem}>
          <Icon size="16px" icon={'clock'} color="#3a5ba2" />

          <Text type={'p'}>
            Runtime Schedule:
            {data.runAt.interval ? ` (${data.runAt.interval / 60} min)` : ''}
          </Text>
        </div>
        <WithTooltip
          className={classes.tooltip}
          placement={'bottom'}
          text={<BodyTooltip data={data.assignedTo || []} name={'Groups:'} />}
        >
          <div className={classes.infoItem}>
            <Icon size="16px" icon={'groupNetwok'} color="#3a5ba2" />
            <Text type={'p'}>Groups: {data.assignedTo?.length || 0}</Text>
          </div>
        </WithTooltip>
      </div>
      {data.platforms.map((platform, index) => (
        <div key={index} className={classes.children}>
          <div className={classes.labelInfoWrap}>
            <Heading>{`${upFirstLetter(platform.platform_type)}:`}</Heading>
            {platform.queries ? (
              platform.queries.map((query, index) => (
                <Text
                  key={index}
                  type={'p'}
                  size={4}
                  className={classes.message}
                >
                  {upFirstLetter(query.type)} :{' '}
                  {(query.query_params || []).map(
                    (param, index) =>
                      `${upFirstLetter(param.value)}${
                        query.query_params.length - 1 !== index
                          ? query.type === 'file'
                            ? ' or '
                            : query.type === 'process'
                            ? ' and '
                            : ', '
                          : ''
                      }`
                  )}
                </Text>
              ))
            ) : (
              <Text type={'s'} size={4} className={classes.message}>
                Define Access Permission :
                {platform.allow ? (
                  <Text className={cn(classes.status, classes.status_true)}>
                    Allow
                  </Text>
                ) : (
                  <Text className={cn(classes.status, classes.status_false)}>
                    Deny
                  </Text>
                )}
              </Text>
            )}
          </div>
        </div>
      ))}
    </>
  );
};

AdditionalContent.propTypes = {
  data: PropTypes.object.isRequired
};

export default AdditionalContent;
